import { render, staticRenderFns } from "./Moriarti.vue?vue&type=template&id=28c707af&scoped=true&lang=pug&"
import script from "./Moriarti.vue?vue&type=script&lang=js&"
export * from "./Moriarti.vue?vue&type=script&lang=js&"
import style0 from "./Moriarti.vue?vue&type=style&index=0&id=28c707af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c707af",
  null
  
)

export default component.exports